import React, { useState, useEffect } from "react";
import { server_django, auth, replace_string } from "../util";
import axios from "axios";
import ReactHtmlParser from "react-html-parser";
import { Link } from "react-router-dom";
import LoadingBox from "./LoadingBox";
import MessageBox from "./MessageBox";
import SpinnerMini from "../UI/SpinnerMini";

const PhotoAlbum = () => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchData = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(server_django + "/albums", {
        auth,
      });
      setLoading(false);
      setPhotos(data.results);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const photoList =
    photos &&
    photos.map((mylist) => {
      return (
        <div
          className="card shadow rounded bg-white"
          key={mylist.id}
          title={mylist.name}
        >
          <img
            className="img-fluid card-img-top"
            src={mylist.header_image?.replace(replace_string, server_django)}
            alt={mylist.name}
          ></img>

          <div className="card-body">
            <Link
              exact
              to={{
                pathname: "/topphotoalbum/" + mylist.id,
                state: [mylist.name],
              }}
            >
              <p className="heading6 text-left">
                {ReactHtmlParser(mylist.name)}
              </p>
            </Link>
          </div>
        </div>
      );
    });
  return (
    <div id="photoAlbum">
      <p className="heading3 text-left">Photo Gallery</p>

      <div className="photoGallary">
        {loading ? (
          <SpinnerMini />
        ) : error ? (
          <MessageBox variant="danger">{error}</MessageBox>
        ) : (
          <div className="card-deck">{photoList}</div>
        )}
      </div>
    </div>
  );
};

export default PhotoAlbum;
